import { EQuestionCodes, EStepCodes } from '../../../../types/requestForm';
export var CHANGED_PHONE_EMPLOYEE_FINAL_STEP = {
  code: EStepCodes.ChangedPhoneEmployeeFinal,
  question: {
    code: EQuestionCodes.ChangedPhoneEmployeeFinal,
    title: 'Изменился номер телефона (шаг 2 из 2)',
    fields: [],
    validation: [],
    actions: []
  },
  nextStep: [{
    conditions: [],
    nextStepCode: null
  }]
};